import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import Parent from './parent';
import ParentDetail from './parent-detail';
import UpdateParentStatus from './parent-status-modal';
const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute path={`${match.url}/:ecoleid/:id/details/update-status`} component={UpdateParentStatus} />
      <ErrorBoundaryRoute path={`${match.url}/:ecoleId/:id/details`} component={ParentDetail} />
      <ErrorBoundaryRoute path={`${match.url}/:ecoleId`} component={Parent} />
    </Switch>
  </>
);

export default Routes;
